import API from "../../api";
import { queryClient } from "../../react-query"
import {formatTemplateData} from "../../formatTemplateData/conecta-pro";
import _ from "lodash";
import {useMerchant} from "../../../store/global/useMerchant";


export class SecurityCodeModel {
  async fetchCodes(cellphones, channel) {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['conecta-pro', 'users-codes', channel],
        queryFn: async () => await API.get(`/security-code?phones=${cellphones.join(',')}`),
        gcTime: 1000 * 10
      })

      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async generateCode(cellphones, channel) {
    try {
      const result = await API.post('security-code/new', {channel, cellphones: formatTemplateData.formatCellphones(_.castArray(cellphones))})
      queryClient.setQueryData(['conecta-pro', 'users-codes', channel], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const cache = queryClient.getQueriesData({queryKey: ['conecta-pro', 'users-codes']})
      return cache.data[0][1].data

    } catch (error) {
      console.error(error)
      return {}
    }
  }
}
